import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  appPageRoot: {
    height: "100%",
    display: "flex",
    flexDirection: "column"
  }
}));
